<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb :page-title="$t('newsLetterMagazine')" :directory="$t('datatables')" :icon="'grid'"/>
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button class="btn btn-primary btn-with-shadow"
                  @click="openNewsMagazineModal">
            {{ $t('add') }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction"/>
<!--    <app-table :id="tableId" :options="options"/>-->

    <app-delete-modal v-if="deleteConfirmationModalActive"
                      :preloader="deleteLoader"
                      modal-id="demo-delete"
                      @confirmed="confirmed"
                      @cancelled="cancelled"/>

    <!-- Modal -->
    <div v-if="showNewsMagazineModal" class="modal d-block" style="background:rgba(0,0,0,0.5)">
      <div class="modal-dialog">
        <div class="modal-content">

          <div class="modal-header">
            <h5>{{ rowData.id ? 'Edit' : 'Add' }} NewsLetter & Magazine</h5>
            <button class="close" @click="showNewsMagazineModal = false">&times;</button>
          </div>

          <div class="modal-body">
            <div class="form-group row align-items-center">
              <label class="col-md-12 mb-md-0">
                {{ $t('type') }}
              </label>
              <app-input class="col-md-12"
                         type="select"
                         v-model="reqData.type"
                         :list="typeList"
                         :placeholder="$t('type')"/>
            </div>
            <div class="form-group row align-items-center">
              <label class="col-md-12 mb-md-0">
                {{ $t('selectPdf') }}
              </label>
              <div class="col-md-12">
                <input type="file" class="form-control col-md-12" @change="handleFileUpload" accept="application/pdf">

                <div v-if="previewUrl || oldBrochure" class="mt-3">
                  <object :data="previewUrl ? previewUrl : oldBrochure" type="application/pdf" width="100%" height="300px">
                    <p>Your browser does not support PDFs. <a :href="previewUrl ? previewUrl : oldBrochure">Download the PDF</a> instead.</p>
                  </object>
                </div>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button class="btn btn-primary mr-2" @click="uploadNewsMagazineData">Submit</button>
            <button class="btn btn-secondary" @click="showNewsMagazineModal = false">Close</button>
          </div>

        </div>
      </div>
    </div>


  </div>
</template>
<script>
import {TableHelpers} from './mixins/TableHelpers';
import * as actions from '../../../../Config/ApiUrl';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import {DELETE_NEWSMAGAZINE} from "../../../../Config/ApiUrl";


export default {
  name: "NewsMagazineData",
  mixins: [TableHelpers,FormMixin],
  data() {
    return {
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      tableId: 'news-table',
      options: {
        name: 'NewsTable',
        url: '/newsletter-magazines/list',
        columns: [],
        showAction: true,
        actions: [
          {
            title: this.$t('edit'),
            icon: 'edit',
            type: 'none',
          },
          {
            title: this.$t('delete'),
            icon: 'trash',
            type: 'none',
            component: 'app-confirmation-modal',
            modalId: 'demo-delete',
          }
        ]
      },
      reqData: {
        type: '',
        file: null
      },
      typeList: [
        {id: 1, value: 'Newsletter'},
        {id: 2, value: 'Magazine'}
      ],
      newsMagazineFile: null,
      oldBrochure: null,
      previewUrl: null,
      showNewsMagazineModal: false,
    }
  },

  created(){
    this.options.columns = [...this.tableColumns, this.actionObj];
  },
  methods: {
    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {

      this.rowData = rowData;

      if (actionObj.title == 'Delete') {

        this.openDeleteModal();
      } else if (actionObj.title == this.$t('edit')) {
        this.editData(rowData);

        // window.location = `${actions.EDIT_OFFICE}${this.rowData.id}`;
      }
    },

    editData(row) {
      this.rowData = row;

      this.reqData.type = row.type_name === 'Newsletter' ? 1 : 2;

      this.reqData.file = null;

      this.oldBrochure = row.source_pdf;
      this.previewUrl = null;

      this.showNewsMagazineModal = true;
    },

    openNewsMagazineModal() {
      this.reqData = {
        type: '',
        file: null
      };

      this.rowData = {};

      this.previewUrl = null;
      this.oldBrochure = null;


      this.showNewsMagazineModal = true;
    },

    handleFileUpload(e) {
      const file = e.target.files[0];

      if (file && file.type === "application/pdf") {

        this.reqData.file = file;
        this.previewUrl = URL.createObjectURL(file);

      } else {
        this.$toastr.e('Please select a valid PDF');
      }
    },

    uploadNewsMagazineData() {
      if (!this.reqData.type) {
        this.$toastr.e('Please select type');
        return;
      }

      if (!this.rowData || !this.rowData.id) {
        if (!this.reqData.file) {
          this.$toastr.e('Please upload PDF');
          return;
        }
      }

      let formData = new FormData();
      formData.append('type', this.reqData.type);
      if (this.reqData.file) {
        formData.append('file', this.reqData.file);
      }

      let url = this.rowData.id
          ? `/newsletter-magazines/update/${this.rowData.id}`
          : `/newsletter-magazines/store`;

      axios.post(url, formData)
          .then(res => {
            console.log(res.data)
            if (res.data.status){
              this.$toastr.s(res.data.message);
              this.reqData = { type: '', file: null };
              this.rowData = {};
              this.previewUrl = null;

              this.$hub.$emit('reload-' + this.tableId);

              this.showNewsMagazineModal = false;
            }else{
              this.$toastr.s(res.data.message);
            }

          })
          .catch(err => {
            this.$toastr.e('Upload failed');
          });
    },

    /**
     * for open confirmation modal
     */
      openDeleteModal() {
        this.deleteConfirmationModalActive = true;
      },

    /**
     * confirmed $emit Form confirmation modal
     */
      confirmed() {
        let url = `${actions.DELETE_NEWSMAGAZINE}${this.rowData.id}`;
        this.deleteLoader=true;
        this.axiosDelete(url)
            .then(response => {
              this.deleteLoader= false;
              $("#demo-delete").modal('hide');
              this.cancelled();
              this.$toastr.s(response.data.message);
            }).catch(({error}) => {

          //trigger after error
        }).finally(() => {
          this.$hub.$emit('reload-' + this.tableId);
        });
      },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },

    reSetData() {
      this.rowData = {};
    },


  },
}
</script>